import React from 'react';
import { connect } from 'react-redux';
import DefaultLayout from './Layout/DefaultLayout';
import SISLayout from './Layout/SISLayout';
import Modal from '../common/Modal';
import Toast from '../common/Toaster';
import Loader from '../common/Loader';
import { removeLayoutModalContent } from '../../actions/webMetaData';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.layout = '';

    let { metaData: { sis = false, name = '' } = {} } = this.props;

    if (sis) {
      this.layout = SISLayout;
    }  else {
      this.layout = DefaultLayout;
    }
  }

  render() {
    let { layout: PageLayout = DefaultLayout } = this;
    let {
      metaData: {
        layoutModal: {
          content = '',
          showModal = false,
          showToast = false,
          toastContent = '',
          optional: { customClass = '', disableOutsideClick = false } = {}
        } = {}
      } = {}
    } = this.props;

    return (
      <PageLayout {...this.props}>
        {showToast && toastContent ? <Toast /> : ''}
        {this.props.children}
        {showModal && content ? (
          <Modal
            name="layout-modal"
            className={`layout-modal ${customClass}`}
            onClose={this.props.removeLayoutModalContent}
            disableOutsideClick={disableOutsideClick}
          >
            {content}
          </Modal>
        ) : (
          ''
        )}
        <Loader name="layout-loader" />
      </PageLayout>
    );
  }
}

const mapStateToProps = state => {
  const { metaData = {} } = state;
  return {
    metaData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    removeLayoutModalContent: () => {
      dispatch(removeLayoutModalContent());
    }
  };
};

export default connect(mapStateToProps, null)(Layout);
